module.exports = __webpack_public_path__ + "static/media/Square.67753eec.svg";